<template>
  <div class="rhlistDrawer">
    <Drawer
      :mask-closable="false"
      class="common-drawer"
      class-name="ssivu-drawer-wrap"
      title="编辑产品点表"
      v-model="value"
      :width="dologwidth"
      @on-close="closeDrawer"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
        class="producditDrawer"
      >
        <FormItem label="属性编码" prop="identifier">
          <Input v-model="formData.identifier" disabled placeholder="请输入" />
        </FormItem>
        <FormItem label="属性名称" prop="propertyName">
          <Input
            v-model="formData.propertyName"
            disabled
            placeholder="请输入"
          />
        </FormItem>
        <FormItem label="属性描述" prop="attributeDesc">
          <Input v-model="formData.attributeDesc" placeholder="请输入" />
        </FormItem>
        <FormItem label="属性分组名称" prop="attrGroupName">
          <Input v-model="formData.attrGroupName" placeholder="请输入" />
        </FormItem>
        <FormItem label="属性分组描述" prop="attrGroupDesc">
          <Input v-model="formData.attrGroupDesc" placeholder="请输入" />
        </FormItem>
        <FormItem label="存储类型">
          <Select disabled v-model="formData.dataType" placeholder="请选择">
            <Option
              :value="data"
              v-for="(data, key) in dataTypeoption"
              :key="key"
              >{{ data }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="计量单位" prop="uom">
          <Input v-model="formData.uom" disabled placeholder="请输入" />
        </FormItem>
        <FormItem label="数据范围">
          <div class="u-flex">
            <Input style="width:78px" disabled v-model="formData.valueFrom"></Input>
            <div style="padding: 0 10px">-</div>
            <Input disabled style="width:78px" v-model="formData.valueTo"></Input>
          </div>
        </FormItem>
        <Divider orientation="left">
          <div style="font-size: 14px">设备配置</div>
        </Divider>
        <!-- <FormItem label="点位配置" prop="pointConfig">
          <Input v-model="formData.pointConfig" placeholder="请输入" />
        </FormItem> -->
        <!-- <FormItem label="寄存器地址" prop="beforeRegis">
          <Input v-model="formData.beforeRegis" placeholder="请输入" />
        </FormItem> -->
        <FormItem label="数据类型" prop="dataType">
          <Select
            ref="pointTypetrue"
            :clearable="pointTypetrue"
            v-model="formData.dataType"
            placeholder="请选择"
          >
            <Option :value="`${key}`" v-for="(data, key) in dataTypes" :key="key"
              >{{ data }}
            </Option>
          </Select>
        </FormItem>

        <form-item label="网关寄存器类型" prop="registerType">
          <Select
            v-model="formData.registerType"
            placeholder="请选择"
            @on-select="handleRegisterTypeSelect"
          >
            <Option v-for="registerType in registerTypeList" :value="registerType.value" :key="registerType.value">
              {{ registerType.value }} - {{ registerType.label }}
            </Option>
          </Select>
        </form-item>
        <form-item label="偏移量" prop="offset">
          <Input placeholder="请输入偏移量" type="number" maxlength="5" v-model="formData.offset" @input="handleOffsetInput" />
        </form-item>
        <form-item label="网关寄存器地址" prop="address">
          <Input disabled placeholder="请选择网关寄存器类型，输入偏移量" v-model="formData.address" />
        </form-item>
        <form-item label="字节序" prop="byteOrder">
          <Select
            v-model="formData.byteOrder"
            placeholder="请选择"
          >
            <Option v-for="byteOrder in byteOrderList" :value="byteOrder.value" :key="byteOrder.value">
              {{ byteOrder.label }}
            </Option>
          </Select>
        </form-item>

        <!-- <Input v-model="formData.pointType" placeholder="请输入" />
        </FormItem> -->
        <!-- <FormItem label="读功能码" prop="readFunctionCode">
          <Select
            ref="readFunctionCodetrue"
            :clearable="readFunctionCodetrue"
            v-model="formData.readFunctionCode"
            placeholder="请选择"
          >
            <Option
              :value="data"
              v-for="(data, key) in readFunctionCodes"
              :key="key"
              >{{ data }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="写功能码" prop="">
          <Select
            ref="writeFunctionCode"
            :clearable="writeFunctionCode"
            v-model="formData.writeFunctionCode"
            placeholder="请选择"
          >
            <Option
              :value="data"
              v-for="(data, key) in writeFunctionCodes"
              :key="key"
              >{{ data }}
            </Option>
          </Select>
        </FormItem> -->
        <!-- <FormItem label="批量操作" prop="batch">
          <Input v-model="formData.batch" placeholder="请输入" />
        </FormItem> -->

        <!-- <FormItem label="交换字节顺序" prop="byteSwap">
          <Select v-model="formData.byteSwap" placeholder="请选择">
            <Option :value="data" v-for="(data, key) in btyboS" :key="key"
              >{{ data }}
            </Option>
          </Select>
          <RadioGroup v-model="formData.byteSwap">
            <Radio v-for="(idx, key) in btyboS" :key="key" :label="idx"></Radio>
          </RadioGroup>
        </FormItem> -->
         <!-- <FormItem label="交换寄存器顺序" prop="registerSwap">
         <Select v-model="formData.registerSwap" placeholder="请选择">
            <Option :value="data" v-for="(data, key) in btyboS" :key="key"
              >{{ data }}
            </Option>
          </Select> 
          <RadioGroup v-model="formData.registerSwap">
            <Radio v-for="(idx, key) in btyboS" :key="key" :label="idx"></Radio>
          </RadioGroup>
        </FormItem>-->
        <FormItem label="小数位数">
          <Slider :disabled="!['10', '11', '12'].includes(formData.dataType)" v-model="formData.dataLen" show-input :min="0" :max="255" :step="1" />
        </FormItem>
        <FormItem label="缩放因子">
          <Input v-model="formData.scaling" type="number" placeholder="请输入" />
        </FormItem>
        <FormItem label="数据转换参数b">
          <Input v-model="formData.convertB" type="number" placeholder="请输入" />
        </FormItem>
        <!-- <FormItem label="轮询周期（毫秒）" prop="pollingPeriod">
          <Input v-model="formData.pollingPeriod" placeholder="请输入" />
        </FormItem> -->
      </Form>
      <div class="drawer-footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="closeDrawer">取消</Button>
      </div>
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Drawer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { editidfe } from "@/api/knowledge/gateway";

const registerTypeList = [
  {
    label: 'Coils',
    value: '0'
  },
  {
    label: 'Input Discrete',
    value: '1'
  },
  {
    label: 'Input Registers',
    value: '3'
  },
  {
    label: 'Holding Registers',
    value: '4'
  },
];
const byteOrderList = [
  {
    label: 'ABCD',
    value: '1'
  },
  {
    label: 'BADC',
    value: '2'
  },
  {
    label: 'CDAB',
    value: '3'
  },
  {
    label: 'DCBA',
    value: '4'
  },
];

export default {
  name: "producteditdrawer",
  props: ["value", "form", "getLists", "timbo", "modelmehods"],
  watch: {
    value(bo) {
      if (bo) {
        let formData = this.$c.deepClone(this.form);
        // if (!formData.dataType) {
        //   formData.dataType = "INT16";
        // }
        if (!formData.readFunctionCode) {
          formData.readFunctionCode = "无";
        }
        if (!formData.writeFunctionCode) {
          formData.writeFunctionCode = "无";
        }

        if (formData.byteSwap == null) {
          formData.byteSwap = "";
        } else if (formData.byteSwap == true) {
          formData.byteSwap = "是";
        } else {
          formData.byteSwap = "否";
        }
        if (formData.registerSwap == null) {
          formData.registerSwap = "";
        } else if (formData.registerSwap) {
          formData.registerSwap = "是";
        } else {
          formData.registerSwap = "否";
        }
        // formData.valueFrom = Number(formData.valueFrom);
        // formData.valueTo = Number(formData.valueTo);
        this.formData = {...formData, offset: `${formData.offset}`};
        this.$nextTick(() => {
          var modal = document.getElementsByClassName("producditDrawer")[0];
          console.log("modal", modal);
          modal.scrollTop = 0;
        });
      }
    },
  },
  data() {
    return {
      writeFunctionCode: false,
      readFunctionCodetrue: false,
      pointTypetrue: false,
      btnLoading: false,
      formData: {},
      registerTypeList,
      byteOrderList,
      ruleValidate: {
        beforeRegis: [
          {
            required: true,
            message: "请填写寄存器地址",
            trigger: "blur",
          },
        ],
        dataType: [
          {
            required: true,
            message: "请填写数据类型",
            trigger: "blur",
          },
        ],
        scaling: [
          {
            required: true,
            message: "请填写缩放因子",
            trigger: "blur",
          },
        ],
        // pointType: [
        //   {
        //     required: true,
        //     message: "请填写数据类型",
        //     trigger: "blur",
        //   },
        // ],
        readFunctionCode: [
          {
            required: true,
            message: "请填写读功能码",
            trigger: "blur",
          },
        ],
        writeFunctionCode: [
          {
            required: true,
            message: "请填写写功能码",
            trigger: "blur",
          },
        ],
        registerType: [
          {
            required: true,
            message: '请选择网关寄存器类型',
            trigger: 'blur',
          },
        ],
        offset: [
        {
            required: true,
            message: '请选择偏移量',
            trigger: 'blur,change',
          },
        ],
        byteOrder: [
        {
            required: true,
            message: '请选择字节序',
            trigger: 'blur',
          },
        ],
      },
      pointTypes: [
        "INT16",
        "INT32",
        "FLOAT",
        "BOOL",
        "DOUBLE",
        "UINT16",
        "UINT32",
        "INT64",
        "UINT64",
      ],
      dataTypes: [
        "",
        "BOOL",
        "INT8",
        "UINT8",
        "INT16",
        "UINT16",
        "INT32",
        "UINT32",
        "INT64",
        "UINT64",
        "FLOAT",
        "DOUBLE",
      ],
      dataTypeoption: ["INT", "DOUBLE", "FLOAT", "TEXT", "DATE"],
      readFunctionCodes: ["无", "0x01", "0x02", "0x03", "0x04"],
      writeFunctionCodes: ["无", "0x05", "0x06", "0x0f", "0x10"],
      // btyboS: ["FALSE", "TRUE"],
      btyboS: ["是", "否"],
    };
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  methods: {
    closeDrawer() {
      this.$emit("input", false);
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.$refs.formValidate.resetFields();
        this.cleartRest();
      });
    },
    // 格式化偏移量
    formatOffset: function (number) {
      const numberString = `${number}`;
      const needLength = 5 - numberString.length;
      let fillingString = '';

      for (let i = 0; i < needLength; i ++) {
        fillingString += '0';
      }

      return `${fillingString}${numberString}`;
    },
    // 网关寄存器地址
    registerAddress: function () {
      this.formData.address = `${this.formData.registerType}${this.formatOffset(this.formData.offset)}`;
    },
    handleRegisterTypeSelect: function () {
      this.registerAddress();
    },
    handleOffsetInput: function () {
      this.registerAddress();
    },
    cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.pointTypetrue = true;
        this.readFunctionCodetrue = true;
        this.writeFunctionCode = true;

        this.$nextTick(async () => {
          this.$refs["pointTypetrue"].clearSingleSelect();

          this.$refs["readFunctionCodetrue"].clearSingleSelect();
          this.$refs["writeFunctionCode"].clearSingleSelect();
          let t1 = setTimeout(() => {
            this.applicationtrue = false;
            this.readFunctionCodetrue = false;
            this.writeFunctionCode = false;

            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    submitForm(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          let formData = this.$c.deepClone({...this.formData, offset: Number(this.formData.offset)});
          console.log('formData.byteSwap',formData.byteSwap)
          if (formData.byteSwap == null) {
           
          } else if (formData.byteSwap == "是") {
            formData.byteSwap = true;
          } else if (formData.byteSwap == "否") {
            formData.byteSwap = false;
          }else{
             formData.byteSwap = null;
          }

          if (formData.readFunctionCode == "无") {
            formData.readFunctionCode = null;
          }
          if (formData.writeFunctionCode == "无") {
            formData.writeFunctionCode = null;
          }

          if (formData.registerSwap == null) {
            formData.registerSwap = "";
          } else if (formData.registerSwap == "是") {
            formData.registerSwap = true;
          } else  if (formData.registerSwap == "否") {
            formData.registerSwap = false;
          }else{
             formData.registerSwap = null;
          }

          // if(!this.formData.valueFrom){
          //   this.formData.valueFrom="0"
          // }
          console.log("222", this.form.valueFrom, this.form.valueTo);
          if (this.form.valueFrom == null) {
            formData.valueFrom = null;
          }
          if (this.form.valueTo == null) {
            formData.valueTo = null;
          }

          if (!['10', '11', '12', 10, 11, 12].includes(formData.dataType)) {
            formData.dataLen = null;
          }

          console.log("formData", formData);

          this.$emit("change", { form: formData });
          this.closeDrawer(); // 关闭弹窗
          this.btnLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.ssivu-drawer-wrap {
  z-index: 100000;
}
</style>
